/**
 * Starts the principal-banner slides fetch + LCP image preload as early as possible
 * (before React root), so the browser can discover the hero image URL without waiting
 * for the main bundle + FirstSection lifecycle.
 *
 * FirstSection reuses the same promise when slideType is principal_banner to avoid a duplicate API call.
 */
/* eslint-disable no-underscore-dangle */

import { getHeroPreloadUrlFromSlides } from './app/utils/imageUrl';

const PRINCIPAL_SLIDES_QUERY =
  'actives=true&sort_column=position&sort_direction=asc&display_length=5&slide_type=principal_banner';

function apiBaseUrl() {
  const isProd = process.env.NODE_ENV === 'production';
  return isProd
    ? process.env.REACT_APP_API_PRODUCTION_URL || ''
    : process.env.REACT_APP_API_STAGING_URL || '';
}

function shouldPrimeSlides() {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  return path === '/' || path === '/es' || path === '/en';
}

function extractSlidesList(json) {
  if (!json || typeof json !== 'object') return [];
  const nested = json.data?.data;
  if (Array.isArray(nested)) return nested;
  if (Array.isArray(json.data)) return json.data;
  return [];
}

function extractFirstSlideImageUrl(json) {
  return getHeroPreloadUrlFromSlides(extractSlidesList(json));
}

function injectImagePreload(href) {
  if (!href || typeof document === 'undefined') return;
  if (document.querySelector('link[data-navimag-hero-lcp="1"]')) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = href;
  link.setAttribute('data-navimag-hero-lcp', '1');
  link.setAttribute('fetchpriority', 'high');
  document.head.appendChild(link);
}

if (shouldPrimeSlides()) {
  if (
    typeof window !== 'undefined' &&
    window.__NAVIMAG_SLIDES_PRINCIPAL_PROMISE__
  ) {
    // Already started from public/lcp-slides-prime.js in index.html
  } else {
    const base = apiBaseUrl();
    if (base) {
      const url = `${base}v1/slides?${PRINCIPAL_SLIDES_QUERY}`;
      window.__NAVIMAG_SLIDES_PRINCIPAL_PROMISE__ = fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        cache: 'no-cache'
      })
        .then(res => {
          if (!res.ok) {
            throw new Error(`slides prime ${res.status}`);
          }
          return res.json();
        })
        .then(json => {
          window.__NAVIMAG_SLIDES_PRINCIPAL_JSON__ = json;
          injectImagePreload(extractFirstSlideImageUrl(json));
          return json;
        })
        .catch(() => {
          delete window.__NAVIMAG_SLIDES_PRINCIPAL_PROMISE__;
          return null;
        });
    }
  }
}
